import subdivisionValidationSchema from '@gasbi/shared/web/Organization/forms/SubdivisionForm/validationSchema';
import { MultiStepFormConfig } from '@gasbi/shared/web/components/MultiStepFormModal';

import {
  cardAddressInitialValues,
  cardAddressStepFields,
  cardAddressValidationSchema,
  oldAddressFields,
  toCardAddressRequest,
} from '@/forms/AddressForm/cardAddress';
import AddressStep from '@/forms/CreateOrganizationForm/steps/AddressStep';

import ContactInfoStep from './steps/ContactInfoStep';
import GeneralInfoStep from './steps/GeneralInfoStep';
import {
  CreateSubdivisionFormSteps,
  CreateSubdivisionFormValues,
  CreateSubdivisionStepComponents,
} from './types';

export const stepComponents: CreateSubdivisionStepComponents = {
  [CreateSubdivisionFormSteps.GeneralInfo]: GeneralInfoStep,
  [CreateSubdivisionFormSteps.ContactInfo]: ContactInfoStep,
  // The same ЄДРА registry address and office as the ГРМ card's.
  [CreateSubdivisionFormSteps.Address]: AddressStep,
};

// The top-level fields of each step: the step's errors keep it from moving on, and the підрозділ's edit action of
// that step validates only them.
export const stepValidationFields: Partial<
  Record<CreateSubdivisionFormSteps, string[]>
> = {
  [CreateSubdivisionFormSteps.GeneralInfo]: [
    'headOrganizationId',
    'parentId',
    'name',
    'fullName',
    'eicSymbol',
    'isActive',
  ],
  [CreateSubdivisionFormSteps.ContactInfo]: ['details'],
  [CreateSubdivisionFormSteps.Address]: cardAddressStepFields,
};

export const subdivisionDefaultValues = {
  parentId: null,
  headOrganizationId: '',
  name: '',
  fullName: '',
  eicSymbol: '',
  ...cardAddressInitialValues,
  details: { phoneNumber: null },
  signatory: null,
  representative: null,
  isActive: true,
};

/** The підрозділ's schema without the old BMS address, with the ЄДРА registry address and the office. */
export const subdivisionCardValidationSchema = subdivisionValidationSchema
  .omit([...oldAddressFields])
  .concat(cardAddressValidationSchema);

const notificationMessages = {
  success: 'Підрозділ успішно створено',
  error: 'Не вдалося створити підрозділ',
};

/**
 * A структурний підрозділ, created in steps as the ГРМ card (GSB-8433), with the old BMS form's fields except the
 * address: the ЄДРА registry address and the office.
 */
export const getFormConfig = (
  headOrganizationId: string,
): MultiStepFormConfig<
  CreateSubdivisionFormValues,
  CreateSubdivisionFormSteps
> => ({
  initialValues: {
    ...subdivisionDefaultValues,
    headOrganizationId,
  } as unknown as CreateSubdivisionFormValues,
  validationSchema: subdivisionCardValidationSchema,
  normalizeRequestData: toCardAddressRequest,
  stepComponents,
  stepValidationFields,
  notificationMessages,
});
